import { useLocation } from "react-router-dom";
import { useIndexAgents } from "@/react/components/SettingsApp/CommunityBot/agentsQueries";
import { settingsNavPathV3 } from "@circle-react/helpers/urlHelpers/settingsNavPathV3";

export const useDisableCommunityInboxLeftSidebar = () => {
  const { pathname } = useLocation();
  const { data: agentsQuery } = useIndexAgents({ currentPage: 1 });
  const shouldHideSidebar = !agentsQuery?.count;
  const isCommunityInboxPage = pathname.includes(
    settingsNavPathV3.community_inbox.index,
  );

  return isCommunityInboxPage && shouldHideSidebar;
};
